import {Country} from "../../../../region/types/Country";
import {divideQueryIntoFriendlyAndRest, offerUrlBuilder} from "../../friendly_offer_list/offer_url_builder";
import {offerUrlParser} from "../../friendly_offer_list/offer_url_parser";
import {shouldOmitOfferListQueryValue} from "../offer_list_url_filters";
import {IOfferListUrlInput, toOfferListType, toOptionalNumber, toRegionSlug} from "../offer_list_url_values";
import {IOfferListRouteParams, IOfferListRouteQuery, IOfferListUrlBuildResult, IOfferListUrlStrategy} from "../types/IOfferListUrlStrategy";

const omitConsumedKeys = (query: IOfferListUrlInput, consumed: Set<string>): IOfferListUrlInput => {
    const rest: IOfferListUrlInput = {};

    Object.entries(query).forEach(([key, value]) => {
        if (consumed.has(key) || shouldOmitOfferListQueryValue(key, value)) {
            return;
        }

        rest[key] = value;
    });

    return rest;
};

export const buildAbroadOfferListParts = (query: IOfferListUrlInput, canonicalizeQuery: boolean): IOfferListUrlBuildResult => {
    const country = toOptionalNumber(query.country);
    const region = toRegionSlug(query.region);
    const built = offerUrlBuilder({
        type: toOfferListType(query.type),
        country,
        region: region ?? ""
    });

    return {
        friendlySlug: built.friendlySlug,
        countrySlug: built.countrySlug,
        abroadRegionSlug: region,
        isAbroad: true,
        query: omitConsumedKeys(query, new Set(["type", "region", "country"])),
        canonicalizeQuery
    };
};

/**
 * Legacy friendly-path strategy: every supported filter stays in the slug
 * (or in the subfilter segment), and whatever is left stays in the query string.
 */
export const friendlyPathUrlStrategy: IOfferListUrlStrategy = {
    canonicalizeQuery: false,
    build(query) {
        const country = toOptionalNumber(query.country);

        if (country && country !== Country.POLAND) {
            return buildAbroadOfferListParts(query, false);
        }

        const normalizedQuery = {
            ...query,
            ...(query.is_luxury === true ? {is_luxury: "true"} : {}),
            ...(query.price_lower_than_average === true ? {price_lower_than_average: "true"} : {})
        };
        const [friendlyValues, restValues] = divideQueryIntoFriendlyAndRest(normalizedQuery as Parameters<typeof divideQueryIntoFriendlyAndRest>[0]);
        const built = offerUrlBuilder({...friendlyValues, country});
        const restQuery = {...restValues} as IOfferListUrlInput;

        if (friendlyValues.construction_end_date === "0") {
            delete restQuery.construction_end_date;
        }

        return {
            friendlySlug: built.friendlySlug,
            offerListSubFilterSlug: built.offerListSubFilterSlug || undefined,
            countrySlug: built.countrySlug,
            query: restQuery,
            canonicalizeQuery: false
        };
    },
    parse(params: IOfferListRouteParams, _routeQuery: IOfferListRouteQuery) {
        if (!params.friendlySlug) {
            return {status: "invalid"};
        }

        const parsed = offerUrlParser(params.friendlySlug, params.offerListSubFilter);

        if (!parsed) {
            return {status: "invalid"};
        }

        return {status: "ok", parsed};
    },
    isIndexable() {
        return true;
    }
};
import {Country} from "../../../../region/types/Country";
import {divideQueryIntoFriendlyAndRest, offerUrlBuilder} from "../../friendly_offer_list/offer_url_builder";
import {offerUrlParser} from "../../friendly_offer_list/offer_url_parser";
import {shouldOmitOfferListQueryValue} from "../offer_list_url_filters";
import {IOfferListUrlInput, toOfferListType, toOptionalNumber, toRegionSlug} from "../offer_list_url_values";
import {IOfferListRouteParams, IOfferListRouteQuery, IOfferListUrlBuildResult, IOfferListUrlStrategy} from "../types/IOfferListUrlStrategy";

const omitConsumedKeys = (query: IOfferListUrlInput, consumed: Set<string>): IOfferListUrlInput => {
    const rest: IOfferListUrlInput = {};

    Object.entries(query).forEach(([key, value]) => {
        if (consumed.has(key) || shouldOmitOfferListQueryValue(key, value)) {
            return;
        }

        rest[key] = value;
    });

    return rest;
};

export const buildAbroadOfferListParts = (query: IOfferListUrlInput, canonicalizeQuery: boolean): IOfferListUrlBuildResult => {
    const country = toOptionalNumber(query.country);
    const region = toRegionSlug(query.region);
    const built = offerUrlBuilder({
        type: toOfferListType(query.type),
        country,
        region: region ?? ""
    });

    return {
        friendlySlug: built.friendlySlug,
        countrySlug: built.countrySlug,
        abroadRegionSlug: region,
        isAbroad: true,
        query: omitConsumedKeys(query, new Set(["type", "region", "country"])),
        canonicalizeQuery
    };
};

/**
 * Legacy friendly-path strategy: every supported filter stays in the slug
 * (or in the subfilter segment), and whatever is left stays in the query string.
 */
export const friendlyPathUrlStrategy: IOfferListUrlStrategy = {
    canonicalizeQuery: false,
    build(query) {
        const country = toOptionalNumber(query.country);

        if (country && country !== Country.POLAND) {
            return buildAbroadOfferListParts(query, false);
        }

        const normalizedQuery = {
            ...query,
            ...(query.is_luxury === true ? {is_luxury: "true"} : {}),
            ...(query.price_lower_than_average === true ? {price_lower_than_average: "true"} : {})
        };
        const [friendlyValues, restValues] = divideQueryIntoFriendlyAndRest(normalizedQuery as Parameters<typeof divideQueryIntoFriendlyAndRest>[0]);
        const built = offerUrlBuilder({...friendlyValues, country});
        const restQuery = {...restValues} as IOfferListUrlInput;

        if (friendlyValues.construction_end_date === "0") {
            delete restQuery.construction_end_date;
        }

        return {
            friendlySlug: built.friendlySlug,
            offerListSubFilterSlug: built.offerListSubFilterSlug || undefined,
            countrySlug: built.countrySlug,
            query: restQuery,
            canonicalizeQuery: false
        };
    },
    parse(params: IOfferListRouteParams, _routeQuery: IOfferListRouteQuery) {
        if (!params.friendlySlug) {
            return {status: "invalid"};
        }

        const parsed = offerUrlParser(params.friendlySlug, params.offerListSubFilter);

        if (!parsed) {
            return {status: "invalid"};
        }

        return {status: "ok", parsed};
    },
    isIndexable() {
        return true;
    }
};
